import { defineStore, storeToRefs } from "pinia";
import { ref } from "vue";

export const useLiveStore = defineStore(
    "live",
    () => {
        const selectedHours = ref<number>(24);

        return {
            selectedHours,
        };
    },
    {
        persist: {
            storage: localStorage,
        },
    }
);

export const useLiveManager = () => storeToRefs(useLiveStore());
